import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-cobalt/10 px-5 py-6 sm:py-12" data-id="element-105" data-mp="223eltma3nb3z">
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-cobalt/40 bg-white/70 p-6 text-center sm:p-12" data-id="element-106" data-mp="222wk4a4o44oo">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep sm:h-16 sm:w-16" data-id="element-107" data-mp="1j4k5w9ywg4m8">
          <ShieldCheckIcon className="h-7 w-7 sm:h-9 sm:w-9" aria-hidden="true" data-id="element-108" data-mp="1edk9d5tozok9" />
        </span>
        <h2 className="mt-4 font-serif-display text-xl font-bold text-ink sm:mt-5 sm:text-3xl" data-id="element-109" data-mp="qnhlz30q36rz">
          Garanzia di rimborso di 7 giorni
        </h2>
        <div className="mt-4 space-y-4 text-[13px] leading-relaxed text-ink/75 sm:mt-6 sm:text-base" data-id="element-110" data-mp="ln28mbgfxza0">
          <p data-id="element-111" data-mp="oxf780y3m9oc">
            Esplora i materiali con tranquillità. Qualora CHIMICA VISIVA™ non fosse adatto alle
            esigenze della tua classe, potrai contattarci entro sette giorni dall’acquisto e
            richiedere il rimborso secondo le condizioni indicate nella nostra politica di rimborso.
          </p>
        </div>
        <div className="mt-6 w-full max-w-md sm:mt-8" data-id="element-112" data-mp="6171kw16bwsi">
          <CTAButton label="OTTIENI CHIMICA VISIVA™ ORA" data-id="element-113" data-mp="62i3srez0whi" />
        </div>
      </motion.div>
    </section>;
}